import { get } from "lodash";

export const resources = (state, resourceType) =>
  get(state, ["marketing", "resources", "byType", resourceType], {});
